<template>
  <div class="products-with-video" v-if="items.length">
    <div class="products-with-video__header">
      <div class="products-with-video__count-wrap" v-if="items.length > 1">
        <div class="products-with-video__navigation">
          <div class="swiper-button-next swiper-button-next__pwv" slot="button-next"></div>
          <div class="swiper-button-prev swiper-button-prev__pwv" slot="button-prev"></div>
        </div>
        <div class="products-with-video__count">
          <span class="products-with-video__count-big">{{ currentSlideCount }}</span>
          <span class="products-with-video__count-delimiter">/</span>
          <span class="products-with-video__count-regular">{{ slidesCount }}</span>
          {{ $t('garden_video_section_count_name') }}
        </div>
      </div>
      <h3 class="products-with-video__title">{{ currentItem[titleByLanguage('video_title')] }}</h3>
    </div>
    <div class="products-with-video__body">
      <div class="products-with-video__slider-wrap">
        <swiper @slide-change="handleSlidesChange"
                ref="swiper"
                class="swiper"
                :options="swiperOption">
          <swiper-slide class="swiper-item" v-for="(item, i) in items" :key="i">
            <main-video :video-id="item.video_hash" preview-quality="maxresdefault" plain-button></main-video>
          </swiper-slide>
        </swiper>
        <div class="products-with-video__navigation">
          <div class="swiper-button-next swiper-button-next__pwv" slot="button-next"></div>
          <div class="swiper-button-prev swiper-button-prev__pwv" slot="button-prev"></div>
        </div>
        <div class="products-with-video__pagination">
          <div class="swiper-pagination"></div>
        </div>
      </div>
      <div class="products-with-video__products-wrap" :class="{ 'custom-scrollbar': !isTouch }">
        <div class="products-with-video__products-scroll-wrap">
          <div class="products-with-video__products-header-wrap">
            <div class="products-with-video__products-header">
              <span class="products-with-video__products-title">{{ $t('garden_video_section_products_title') }}</span>
              <span class="products-with-video__products-text">
                {{ currentItem[titleByLanguage('products_description')] }}
              </span>
            </div>
          </div>
          <ul class="products-with-video__products-list" :class="{ 'custom-scrollbar': !isTouch }">
            <li class="products-with-video__product-item" v-for="(product, i) in currentItem.products_list" :key="i">
              <ProductsWithVideoProductCard
                :product="product"
                :list="transliterate(currentItem.video_title_ru)"
                :position="i + 1"
              />
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

import { mapState } from 'vuex'
import { isTouch } from '../../../mixins/isTouchDevice'
import { transliteration } from '../../../mixins/transliteration'

import MainVideo from '../product-page/video-gallery/MainVideo'
import ProductsWithVideoProductCard from './ProductsWithVideoProductCard'

export default {
  name: 'ProductsWithVideo',
  mixins: [isTouch, transliteration],
  computed: {
    ...mapState({
      language: state => state.translation.language
    }),
    slidesCount () {
      return this.items.length.toString().padStart(2, '0')
    },
    currentSlideCount () {
      return (this.activeItemIndex + 1).toString().padStart(2, '0')
    },
    currentItem () {
      return this.items[this.activeItemIndex]
    }
  },
  methods: {
    titleByLanguage (titleKey) {
      return titleKey + '_' + this.language
    },
    handleSlidesChange () {
      const { activeIndex } = this.$refs.swiper.$swiper

      this.activeItemIndex = activeIndex
    }
  },
  props: {
    items: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: ''
    },
    titleRu: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      activeItemIndex: 0,
      swiperOption: {
        watchOverflow: true,
        watchSlidesVisibility: true,
        spaceBetween: 20,
        slidesPerView: 1,
        navigation: {
          nextEl: '.swiper-button-next__pwv',
          prevEl: '.swiper-button-prev__pwv'
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        simulateTouch: !isTouch,
        touchStartPreventDefault: false,
        preloadImages: false,
        lazy: true
      }
    }
  },
  components: {
    ProductsWithVideoProductCard,
    MainVideo,
    Swiper,
    SwiperSlide
  }
}
</script>

<style scoped lang="sass">

@import "../../../styles/swiper/swiper"

.products-with-video
  background-color: #fff

  +mmin($tablet--hor)
    background-color: transparent

.products-with-video__header
  padding: 0 15px

.products-with-video__count-wrap
  position: relative
  display: flex
  justify-content: center

  +mmin($tablet--hor)
    justify-content: flex-start

  .products-with-video__navigation
    width: 100%
    max-width: 300px
    position: absolute
    top: calc(50% + 5px)

    +mmin($tablet--hor)
      display: none

.products-with-video__count-big
  font-size: 44px
  margin-right: 4px

  +mmin($tablet--hor)
    font-size: 64px
    margin-right: 8px

.products-with-video__count-delimiter
  font-size: 16px
  margin-right: 2px

  +mmin($tablet--hor)
    font-size: 24px
    margin-right: 5px

.products-with-video__count-regular
  font-size: 16px
  margin-right: 6px

  +mmin($tablet--hor)
    font-size: 20px
    margin-right: 10px

.products-with-video__title
  display: inline-block
  font-size: 18px
  font-weight: 500
  text-transform: uppercase
  margin: 30px 0

  +mmin($tablet--hor)
    font-size: 24px

.products-with-video__body

  +mmin($tablet--hor)
    display: flex
    justify-content: space-between
    padding: 0 15px

.products-with-video__slider-wrap
  position: relative
  width: 100%

  +mmin($tablet--hor)
    width: 68%

.products-with-video__products-wrap
  width: 100%
  background-color: #fff
  position: relative

  +mmin($tablet--hor)
    width: 31%
    overflow: auto

.products-with-video__products-scroll-wrap

  +mmin($tablet--hor)
    position: absolute
    padding: 40px 25px

.products-with-video__products-header-wrap
  padding: 0 15px

  +mmin($tablet--hor)
    padding: 0

.products-with-video__products-header
  position: relative
  display: flex
  flex-flow: column
  padding-left: 37px
  margin-bottom: 20px

  +mmin($tablet--hor)
    padding-left: 45px
    margin-bottom: 30px

  &:before
    position: absolute
    display: block
    content: ''
    width: 22px
    height: 22px
    background-image: url('/img/svgo/garden-page/product-bag.svg')
    background-size: contain
    background-repeat: no-repeat
    left: 0
    top: 0

    +mmin($tablet--hor)
      width: 30px
      height: 30px

.products-with-video__products-title
  display: inline-block
  font-size: 14px
  font-weight: 500
  text-transform: uppercase
  margin-bottom: 15px

  +mmin($tablet--hor)
    font-size: 18px
    margin-bottom: 10px

.products-with-video__products-text
  font-size: 14px
  color: $placeholder-color

  +mmin($tablet--hor)
    font-size: 16px

.products-with-video__products-list
  +list-unstyled
  display: flex
  flex-flow: row nowrap
  overflow: auto
  padding: 0 15px

  +mmin($tablet--hor)
    flex-flow: column
    padding: 0

.products-with-video__product-item
  min-width: 325px

  +mmin($tablet--hor)
    min-width: auto

  &:not(:last-child)
    margin-right: 10px

    +mmin($tablet--hor)
      margin-right: 0
      margin-bottom: 5px

//.products-with-video__product-card
//  display: flex
//  flex-flow: row nowrap
//  padding: 15px
//  border: 1px solid $nd-border-color
//  border-radius: 3px
//
//.products-with-video__product-image-wrap
//  width: 85px
//  height: 85px
//  object-fit: contain
//  flex-shrink: 0
//
//.products-with-video__product-image
//  display: block
//  width: 100%
//  font-size: 8px
//
//.products-with-video__product-info-wrap
//  width: 100%
//  display: flex
//  flex-flow: column
//  margin-left: 10px
//
//.products-with-video__product-title
//  -webkit-box-orient: vertical
//  -webkit-line-clamp: 2
//  color: $text-color
//  font-weight: 400
//  font-size: 14px
//  margin-bottom: 5px
//
//.products-with-video__product-price
//  display: block
//  font-size: 16px
//  font-weight: 500
//  color: $text-color
//  margin-bottom: 10px
//
//.products-with-video__product-link
//  display: block
//  width: 100%
//  max-width: max-content
//  padding: 6px 22px 7px
//  background-color: $main-color
//  border-radius: 3px
//  font-size: 12px
//  color: $white-text-color
//
//  &:hover
//    background-color: $main-color--hover

.products-with-video__slider-wrap
  .products-with-video__navigation
    display: none

    +mmin($tablet--hor)
      width: calc(100% - 50px)
      display: block
      position: absolute
      top: calc(50% + 5px)
      left: 25px
      right: 25px

.products-with-video__pagination ::v-deep
  width: 100%
  z-index: 1
  padding: 15px 0

  +mmin($tablet--hor)
    position: absolute
    bottom: 20px
    padding: 0

  .swiper-pagination
    position: static

  .swiper-pagination-bullet
    background: $text-color
    opacity: .2

    +mmin($tablet--hor)
      background: $white-text-color
      opacity: .4

    &:not(:last-child)
      margin-right: 5px

      +mmin($tablet--hor)
        margin-right: 10px

  .swiper-pagination-bullet-active
    opacity: .6

    +mmin($tablet--hor)
      opacity: 1
</style>
